import React from 'react';
import DisclaimersPage from './DisclaimersPage';

// This wrapper is now handled directly in DisclaimersPage.tsx
// with DisclaimersPageWithNavigation component
const DisclaimersPageWrapper = () => {
  return <DisclaimersPage />;
};

export default DisclaimersPageWrapper;
